import { alpha, Theme } from '@mui/material/styles';

/** Readable @mention chip in both light and dark mode. */
export const mentionChipSx = (theme: Theme) => {
  const isDark = theme.palette.mode === 'dark';
  // Theme primary.main (#1e3a8a) is too dark for text on dark surfaces.
  const mentionColor = isDark ? '#93c5fd' : theme.palette.primary.main;

  return {
    color: mentionColor,
    fontWeight: 600,
    bgcolor: alpha(mentionColor, isDark ? 0.18 : 0.12),
    borderRadius: '4px',
    px: 0.5,
    py: '1px',
    whiteSpace: 'nowrap' as const,
  };
};
